/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';

import {HttpClient} from "@angular/common/http";
import {DynamiclinkService} from "./dynamiclink.service";
import {RootScopeService} from "./rootscope.service";
import {Idle, WindowInterruptSource} from "@ng-idle/core";


@Injectable({
    providedIn: 'root'
})
export class SessionService {

    public id;
    public info;
    private dynamicLinkService: DynamiclinkService;

    private httpClient: HttpClient;

    constructor(dynamicLinkService: DynamiclinkService, private rootScope: RootScopeService, httpClient: HttpClient, private idle: Idle) {
        console.log("init session service")
        this.dynamicLinkService = dynamicLinkService;
        this.httpClient = httpClient;

        // The sessionID
        this.id = undefined;

        // The session Info
        this.info = undefined;

        var src = 'images/documents/evidenceUserHelper.json';
        this.rootScope.get().evidenceUserHelperMap = {}
        //Get evidenceUserHelper.json data

        let that = this;
        this.httpClient.get(src).toPromise().then(function (response: any) {
            console.debug('loading json file for evidence user helper');
            that.rootScope.get().evidenceUserHelperMap = response;
        });


    }


    getUrl(name) {
        if (typeof this.info === 'undefined' || typeof this.info[name] === 'undefined' || this.info[name] === null) {
            return null;
        }
        return this.dynamicLinkService.dynamize(this.info[name]);
    }

    updateProperties(sessionId): Promise<void> {
        //update config
        if (this.id === undefined || this.id !== sessionId) {

            let that = this;
            return this.httpClient.get('/config/front').toPromise().then(function saveConfig(response: any) {
                that.rootScope.get().defaultProperties = response;
            }).then(() => {
                return this.httpClient.get('/config/front?sessionId=' + sessionId).toPromise().then(function saveConfig(response: any) {
                    let newProperties = response;

                    that.rootScope.get().properties = newProperties;
                    console.log('update properties =', newProperties);

                    that.idle.setIdle(newProperties.session.idle)
                    that.idle.setTimeout(newProperties.session.timeout)
                    that.idle.setInterrupts([new WindowInterruptSource('keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll routeChange')])
                });
            })
        } else {
            return Promise.resolve();
        }
    }

    // get external OK url
    getUrlOk() {
        return this.getUrl('urlOk');
    }

    // get external KO url
    getUrlKo() {
        return this.getUrl('urlKo');
    }

    // get external Cancel url
    getUrlCancel() {
        return this.getUrl('urlCancel');
    }

    // get external url on hold
    getUrlOnHold() {
        return this.getUrl('urlOnHold');
    }

    getCurrentSessionId() {
        return this.id;
    }

    getErrorRedirectionStrategy() {
        return {canRedirect: (this.getUrlKo() !== null), url: this.getUrlKo()}
    }
}
